module.exports = __webpack_public_path__ + "media/images/favicons/favicon-thursday-c2ea7cc316e1722e4ae60b13a3edbac8.ico";